import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import QRCode from "react-qr-code";

import { remToPx } from "@/shared/utils/viewmode";
import { systemActions } from "@/store/actions";
import EgwWebFont from "src/assets/EgwWebFont";
import IconButton from "@/shared/components/IconButton/IconButton";
import { Button, Input, Typography } from "@/components/index";
import { BUTTON_SIZES } from "@/shared/components/Button/Button.constants";
import { NEXT_URLS } from "@/utils/routes/routes.constants";

import styles from "./CreateQRcode.module.scss";

const handleImageDownload = () => {
  const svg = document.getElementById("QRCode");
  const svgData = new XMLSerializer().serializeToString(svg);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  img.onload = () => {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    const pngFile = canvas.toDataURL("image/png");
    const downloadLink = document.createElement("a");
    downloadLink.download = "QRCode";
    downloadLink.href = `${pngFile}`;
    downloadLink.click();
  };
  img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};

const CreateQRcode = ({ value }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const isReader = router.asPath.includes(NEXT_URLS.read);
  const [qrCodeValue, setQrCodeValue] = useState(value || "");
  const [isOpenIconTooltip, setIsOpenIconTooltip] = useState(false);
  const dispatch = useDispatch();

  return (
    <div className={styles["qr-code_wrap"]}>
      <div className={styles["qr-code-image"]}>
        <QRCode size={remToPx(16)} id="QRCode" value={qrCodeValue} />
      </div>
      <Typography tag="p" variant="body2" align="left" color="text-inactive">
        Link:
      </Typography>
      <Input
        readOnly
        onChange={(e) => setQrCodeValue(e.target.value)}
        className={styles["qr-code_input"]}
        value={qrCodeValue}
      />
      <div className={styles["qr-code_action"]}>
        <IconButton
          className={classNames(styles["qr-code_icon-button"], styles.tooltip)}
          icon={EgwWebFont.info}
          size={BUTTON_SIZES.small}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpenIconTooltip(!isOpenIconTooltip);
          }}>
          <Typography
            tag="span"
            className={classNames(styles["tooltiptext"], {
              [styles["active"]]: isOpenIconTooltip,
            })}
            variant="body2">
            {t("qrCodeInfo")}
          </Typography>
        </IconButton>
        <div
          className={classNames(styles["qr-code-buttons"], isReader ? styles["two-column"] : "")}>
          <Button
            onClick={() => {
              dispatch(
                systemActions.actionCopy(qrCodeValue, {
                  successMessage: t("linkCopied"),
                  errorMessage: t("linkNotCopied"),
                }),
              );
            }}
            size={BUTTON_SIZES.medium}
            className={styles["qr-code_button"]}>
            {" "}
            {t("copy")}
          </Button>
          {isReader && (
            <Button
              onClick={handleImageDownload}
              size={BUTTON_SIZES.medium}
              color={Button.color.secondary}
              className={styles["qr-code_button"]}>
              {" "}
              {t("download")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

CreateQRcode.propTypes = {
  value: PropTypes.string,
};

export default CreateQRcode;
